export default {
  // Snackbar
  linkCopiedToClipboard: 'Link copiado para a área de transferência!',

  // KPI selector
  kpiLabel: 'KPI',

  // Share plan tooltip and dialog
  sharePlan: 'Compartilhar Plano',
  shareDialogTitle: 'Compartilhar "{name}"',
  sharingDisabled: 'Compartilhamento desabilitado',
  sharingEnabled: 'Compartilhamento habilitado',
  creatingLink: 'Criando Link...',
  done: 'Pronto',

  // Metrics
  budgetLabel: 'Orçamento ({unit})',
  predictedLabel: '{kpiName} Projetadas ({unit})',
  restrictions: 'Restrições',

  // Restriction types
  restrictionUnrestricted: 'Sem restrição',
  restrictionMoreThan: 'Mais de',
  restrictionLessThan: 'Menos de',
  restrictionBetween: 'Entre',
  restrictionExactly: 'Exatamente',
  restrictionSpendIn: 'Gastar em',
  restrictionAnd: 'e',

  // Tabs
  tabFullPeriodSummary: 'Resumo do Período Completo',
  tabMonthlyDetailView: 'Visão Detalhada Mensal',
  tabWeeklyDetailView: 'Visão Detalhada Semanal',
  tabTouchpoints: 'Pontos de Contato',
  tabSegments: 'Segmentos',
  tabAdmin: 'Admin',

  // Chart titles
  salesDecompositionTitle: 'Decomposição de {kpiName} ({unit})',
  mediaKpiByChannelTitle: '{kpiName} de Mídia por Canal ({unit})',
  mediaSpendCalendarTitle: 'Calendário de Investimento em Mídia ({unit})',
  mediaMixTitle: 'Mix de Mídia ({unit})',

  // Admin tab
  rawOutputLabel: 'Saída RAW',
  injectChanges: 'Injetar alterações',

  // Loading
  loading: 'Carregando...'
}
